import * as SubsidySuggestPopup from './SubsidySuggestPopup.css';
export default {
    SubsidySuggestPopup
};
